"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
exports.relationships = [
    {
        left: ["NP", "WDT", "WP", "WP$"],
        right: ["VP", "VB"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "NSUBJ"
    },
    {
        left: ["NP"],
        right: ["VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 2,
        delay: 0,
        direction: "->",
        label: "NSUBJPASS"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "DOBJ"
    },
    {
        left: ["WDT", "WP", "WP$"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 1,
        direction: "->",
        label: "DOBJ"
    },
    {
        left: ["VP", "VBN", "VB"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 5,
        direction: "<-",
        label: "CCOMP"
    },
    {
        left: ["EX"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 2,
        delay: 0,
        direction: "->",
        label: "EXPL"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["EX"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "EXPL"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["JJR", "ADV"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "ADVMOD"
    },
    {
        left: ["JJR", "ADV"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 3,
        delay: 0,
        direction: "->",
        label: "ADVMOD"
    },
    {
        left: ["ADV"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 3,
        delay: 0,
        direction: "->",
        label: "ADVMOD"
    },
    {
        left: ["JJR", "VB", "VP", "VBN"],
        right: ["PP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 1,
        direction: "<-",
        label: "ADVMOD"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["EM"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "DISCOURSE"
    },
    {
        left: ["EM"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "DISCOURSE"
    },
    {
        left: ["EM"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "DISCOURSE"
    },
    {
        left: ["NP"],
        right: ["EM"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "DISCOURSE"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["PRT"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 5,
        delay: -1,
        direction: "<-",
        label: "VPRT"
    },
    {
        left: ["PRT"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "VPRT"
    },
    {
        left: ["NP"],
        right: ["PRT"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 5,
        delay: -1,
        direction: "<-",
        label: "VPRT"
    },
    {
        left: ["PRT"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "VPRT"
    },
    {
        left: ["MD", "TO"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "AUX"
    },
    {
        left: ["MD", "TO"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "AUX"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["VP", "VB"],
        leftTokens: ["be", "can", "do", "have", "may", "will", "shall", "go"],
        rightTokens: [],
        maxDistance: 4,
        delay: 0,
        direction: "->",
        label: "AUX"
    },
    {
        left: ["VBN"],
        right: ["VBN"],
        leftTokens: ["be", "can", "do", "have", "may", "will", "shall"],
        rightTokens: [],
        maxDistance: 4,
        delay: 0,
        direction: "->",
        label: "AUX"
    },
    {
        left: ["VP", "VB"],
        right: ["VBN"],
        leftTokens: ["be", "can", "do", "have", "may", "will", "shall"],
        rightTokens: [],
        maxDistance: 4,
        delay: 0,
        direction: "->",
        label: "AUXPASS"
    },
    {
        left: ["PP"],
        right: ["VB", "VP", "VBN"],
        leftTokens: ["that", "because", "by", "despite", "although", "if", "of", "though", "unless", "whereas", "whether"],
        rightTokens: [],
        maxDistance: -1,
        delay: 1,
        direction: "->",
        label: "COMPMARK"
    },
    {
        left: ["PP"],
        right: ["VB", "VP", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 4,
        delay: 1,
        direction: "->",
        label: "ADVMARK"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["ADJ"],
        leftTokens: ["be"],
        rightTokens: [],
        maxDistance: 4,
        delay: 0,
        direction: "->",
        label: "COP"
    },
    {
        left: ["VP", "VB", "VBN", "ADJ", "ADJP", "NP"],
        right: ["CD"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "NUMMOD"
    },
    {
        left: ["CD"],
        right: ["VP", "VB", "VBN", "NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 0,
        delay: -1,
        direction: "->",
        label: "NUMMOD"
    },
    {
        left: ["ADV", "VBN"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "NMOD"
    },
    {
        left: ["VB", "VP", "VBN"],
        right: ["TO"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "NMOD"
    },
    {
        left: ["NP"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 4,
        delay: 4,
        direction: "->",
        label: "NMOD"
    },
    {
        left: ["NP"],
        right: ["PP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: 4,
        delay: 4,
        direction: "<-",
        label: "ACL"
    },
    {
        left: ["VP", "VB", "VBN"],
        right: ["ADJ", "ADJP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "AMOD"
    },
    {
        left: ["ADJ", "ADJP"],
        right: ["VP", "VB", "VBN"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 4,
        direction: "->",
        label: "AMOD"
    },
    {
        left: ["WDT", "WP"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "<-",
        label: "DET"
    },
    {
        left: ["TO", "PP"],
        right: ["NP"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 0,
        direction: "->",
        label: "CASE"
    },
    {
        left: [],
        right: ["PUNCT"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 3,
        direction: "<-",
        label: "PUNCT"
    },
    {
        left: [],
        right: ["PUNCT"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 4,
        direction: "->",
        label: "PUNCT"
    },
    {
        left: [],
        right: ["PUNCT"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: 4,
        direction: "->",
        label: "PUNCT"
    },
    {
        left: ["CC"],
        right: [],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: -1,
        direction: "->",
        label: "CC"
    },
    {
        left: [],
        right: ["CC"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: -1,
        direction: "<-",
        label: "CC"
    },
    {
        left: [],
        right: ["UH"],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: -1,
        direction: "<-",
        label: "INTERJ"
    },
    {
        left: ["UH"],
        right: [],
        leftTokens: [],
        rightTokens: [],
        maxDistance: -1,
        delay: -1,
        direction: "->",
        label: "INTERJ"
    }
];
